import { useState } from 'react';
import { useFormContext } from 'react-hook-form';

import { useAppSelector } from '@/Application/Hooks/Redux';

import type { TTransformedFees } from '../../../../interfaces';
import { getTransformedFees } from '../../../../utils';

interface IInputNumberOfFeesProps {
  className?: string;
  isCencosud?: boolean;
}
export const InputNumberOfFees = ({
  className,
  isCencosud
}: IInputNumberOfFeesProps) => {
  const { availablePayments } = useAppSelector((state) => state.billing);
  const { creditFees, cencoFees } = availablePayments || {};

  const [installmentPayments] = useState<TTransformedFees[]>(() =>
    getTransformedFees(isCencosud ? cencoFees : creditFees)
  );

  const form = useFormContext<IFormFields>();

  const onChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const value = e.target.value;
    form.setValue('installments', Number(value) || 1);
  };

  return (
    <div
      className={`co-flex co-w-full co-flex-col co-gap-[8px] co-h-fit ${className}`}
    >
      <LabelNumberOfFees />
      <div className="co-flex co-flex-col co-gap-[4px] co-h-auto">
        <select
          className="co-px-16px co-w-full co-text-body1 co-h-[46px] co-border-1 co-border-[#B4C2CB] co-rounded-[8px] co-form-select focus:outline-none focus:co-ring-1 co-transition-all co-duration-300 co-text-[#485760] co-font-normal"
          id={'fees-input'}
          {...form.register('installments', {
            onChange: (e) => {
              onChange(e);
            }
          })}
        >
          <option value="" disabled>
            Seleccionar
          </option>
          {installmentPayments.map((option, index) => (
            <option key={index} value={option.value}>
              {option.name}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

const LabelNumberOfFees = () => {
  return (
    <label
      className="co-flex co-w-fit co-text-[12px] co-font-semibold co-leading-[16px] co-text-[#363F45]"
      htmlFor="number-of-fees"
    >
      Número de cuotas
    </label>
  );
};
